import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrBulkCreateTermsPayload } from 'api/actions/hr-bulk-create-terms/hr-bulk-create-terms-payload';
import { HrBulkCreateTermsPathParameters } from 'api/actions/hr-bulk-create-terms/hr-bulk-create-terms-path-parameters';
import { HrBulkCreateTermsResponse } from 'api/actions/hr-bulk-create-terms/hr-bulk-create-terms-response';

type HrBulkCreateTermsQueryParameters = Record<string, any>;

/**
 * The path of the HrBulkCreateTerms action.
 */
export const hrBulkCreateTermsActionPath = new SweetPath<keyof HrBulkCreateTermsPathParameters>(
  '/api/hr/terms/bulk-create',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrBulkCreateTerms actions.
 */
export default function createHrBulkCreateTermsAction(axios: AxiosInstance) {
  return function hrBulkCreateTermsAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HrBulkCreateTermsQueryParameters;
    payload: HrBulkCreateTermsPayload;
  }) {
    const path = hrBulkCreateTermsActionPath.original;

    return axios.request<HrBulkCreateTermsResponse, HrBulkCreateTermsResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
